module.exports = __webpack_public_path__ + "img/cancel-full-screen.09533a37.svg";